import { AsyncActionHandler } from 'action-handler';
import { fetchHasSettings } from 'action-utils';

export default new AsyncActionHandler({
  name: 'fetch_has_settings',
  stateProp: 'settings',
  defaultState: {
    settings: {}
  },
  handler(appId) {
    return async (_, getState) => ({
      settings: await fetchHasSettings([appId], getState())
    });
  },
  reduce(state, { settings }) {
    return {
      settings: {
        ...state.settings,
        ...settings
      }
    };
  }
});
